<template>
    <Navbar />
    <main class="py-5 px-2">
        <div class="d-flex align-items-end flex-wrap px-4">
            <div class="col-12 col-sm-4 mb-4 mb-sm-0">
                <router-link to="/dashboard" class="text-second router-link fs-3" v-if="this.$route.name !== 'DashboardIndex'">
                    <i class="fa-solid fa-chevron-left"></i>
                    {{ $t('Dashboard.back') }}
                </router-link>
            </div>
            <div class="col-12 col-sm-4 text-center mb-4 mb-sm-0">
                <h1 class="text-first">
                    {{ $t(`Dashboard.${this.$route.name}.RouteName`) }}
                </h1>
            </div>
            <div class="col-12 col-sm-4 text-center text-sm-end" v-if="this.$route.name === 'BankCards'">
                <router-link to="/dashboard/travels/bank_cards/add"
                    class="btn btn-auth btn-auth-third text-decoration-none">
                    {{ $t('Dashboard.BankCards.addBankCard') }}
                </router-link>
            </div>
        </div>
        <router-view></router-view>
    </main>
</template>

<script>
import Navbar from '@/components/Navbar.vue'
export default {
    name: 'DashboardView',
    components: {
        Navbar
    }
}
</script>

<style lang="scss" scoped>
main {
    box-shadow: inset 0 5px 10px 0 rgba(0, 0, 0, 0.3);
}
</style>